document.addEventListener('DOMContentLoaded', function() {
  initProductGallery();

  document.body.addEventListener(
    'load',
    (e) => {
      if (
        e.target.tagName === 'IMG' &&
        e.target.closest('.fslightbox-container')
      ) {
        e.target.classList.toggle(
          'is-landscape',
          e.target.naturalWidth > e.target.naturalHeight
        );
      }
    },
    true
  );
});

// Listen for variant changes which occur when swatches are clicked
window.addEventListener('ab:variant-option-selected', function() {
  setTimeout(initProductGallery, 100);
});

function initProductGallery() {
  const galleryContainer = Array.from(document.querySelectorAll('[data-variant-gallery]'))
    .find(el => el.offsetParent !== null);
  if (!galleryContainer) return;

  const gallery = galleryContainer.querySelector('.product__media-list');
  if (!gallery) return;

  if (window.innerWidth >= 750) {
    return;
  }

  let currentMediaWidthVisible = false;  
  let currentVisibleElement = null;

  function updateGalleryHeight(visibleLandscapeElement) {
    if (visibleLandscapeElement) {
      const mediaElement = visibleLandscapeElement.querySelector('img, video');
      if (mediaElement) {
        gallery.style.height = `${mediaElement.offsetHeight}px`;
        gallery.classList.add('carousel-animation');
      }
    } else {
      gallery.style.height = '';
    }
  }

  const options = {
    root: gallery,
    threshold: 0.6 
  };

  const callback = (entries) => {
    let foundMediaWidth = false;
    let visibleElement = null;
    
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.target.classList.contains('product-media-width')) {
        foundMediaWidth = true;
        visibleElement = entry.target;
      }
    });
    
    if (foundMediaWidth !== currentMediaWidthVisible || 
        (foundMediaWidth && currentVisibleElement !== visibleElement)) {
      currentMediaWidthVisible = foundMediaWidth;
      currentVisibleElement = visibleElement;
      updateGalleryHeight(visibleElement);
    }
  };

  if (window.productGalleryObserver) {
    window.productGalleryObserver.disconnect();
  }

  const observer = new IntersectionObserver(callback, options);
  window.productGalleryObserver = observer;
  
  gallery.querySelectorAll('li').forEach(li => observer.observe(li));
  
  const visibleItem = Array.from(gallery.querySelectorAll('li.product-media-width')).find(
    li => {
      const rect = li.getBoundingClientRect();
      const galleryRect = gallery.getBoundingClientRect();
      return rect.left >= galleryRect.left && 
             rect.right <= galleryRect.right && 
             rect.left < rect.right;
    }
  );
  
  if (visibleItem) {
    updateGalleryHeight(visibleItem);
  }
}
